import React, { FC } from 'react';

import { transformGqlToAgeRestriction } from '../../../../lib/transform-age-restriction';
import { AgeRestrictionContainer } from '../../../feature-player/ui/skin/age-restriction/container';
import { useReadMovieTrailerPlayerBaseInfo } from '../../../movie-trailer-player/hooks/use-read-movie-trailer-player-base-info';
import { useCurrentTrailerStream } from '../../hooks/use-current-trailer-stream';

type Props = {
    contentId: string;
};

export const TrailerAgeRestriction: FC<Props> = ({ contentId }) => {
    const trailer = useReadMovieTrailerPlayerBaseInfo(contentId);
    const ageRestriction = trailer?.ageRestriction;
    const streamVideoMetas = useCurrentTrailerStream(contentId)?.streamMeta?.videoMetas?.[0];

    return (
        <AgeRestrictionContainer
            age={ageRestriction ? transformGqlToAgeRestriction(ageRestriction) : undefined}
            videoHeight={streamVideoMetas?.height || undefined}
            videoWidth={streamVideoMetas?.width || undefined}
        />
    );
};
